/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PostApiJingleCollectionsMutationRequest, PostApiJingleCollectionsMutationResponse, PostApiJingleCollections400, PostApiJingleCollections401, PostApiJingleCollections403, PostApiJingleCollections500 } from "../../types/PostApiJingleCollections.ts";
import { postApiJingleCollectionsMutationResponseSchema, postApiJingleCollectionsMutationRequestSchema } from "../../zod/JingleCollectionSchemas/postApiJingleCollectionsSchema.ts";

function getPostApiJingleCollectionsUrl() {
  const res = { method: 'POST', url: `/api/jingle-collections` as const }  
  return res
}

/**
 * @summary Создание подборки джинглов
 * {@link /api/jingle-collections}
 */
export async function postApiJingleCollections({ data }: { data?: PostApiJingleCollectionsMutationRequest }, config: Partial<RequestConfig<PostApiJingleCollectionsMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = postApiJingleCollectionsMutationRequestSchema.parse(data)  
  
  const res = await request<PostApiJingleCollectionsMutationResponse, ResponseErrorConfig<PostApiJingleCollections400 | PostApiJingleCollections401 | PostApiJingleCollections403 | PostApiJingleCollections500>, PostApiJingleCollectionsMutationRequest>({ method : "POST", url : getPostApiJingleCollectionsUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return postApiJingleCollectionsMutationResponseSchema.parse(res.data)
}